<template>
  <div id="shops">
    <shop-nav-bar :id="storeId"></shop-nav-bar>
    <div class="head_content">
      <div class="bgImg">
        <img :src="imgSrc" />
      </div>
      <div class="store_navigation">
        <van-row>
          <van-col>
            <div class="head_img">
              <img :src="basicMessage.logoPictureUrl" alt />
            </div>
          </van-col>
          <van-col>
            <span class="store-name">{{ basicMessage.name }}</span>
            <div class="head_watch">
              <span class="follow-num"
                >已有{{ basicMessage.follows }}人关注</span
              >
              <van-tag
                @click="notWatchClick"
                v-if="watchIco"
                plain
                round
                text-color="#fff"
                >关注</van-tag
              >
              <van-tag
                @click="watchClick"
                v-else
                style="background: #e1dbe8"
                plain
                round
                text-color="#fff"
                >已关注</van-tag
              >
            </div>
          </van-col>
        </van-row>
        <van-row v-if="basicMessage.merchantType !== 4" gutter="3">
          <van-col span="16" class="head_addres">
            <div>
              <img src="@/assets/images/addresdefault.png" alt />
              <span>{{ basicMessage.address }}</span>
            </div>
          </van-col>
          <van-col class="head_title">
            <div class="head_phone">
              <span v-if="inApp" @click="navigationClick">导航到店&ensp;></span>
              <img @click="showPopup" src="@/assets/images/redphone.png" alt />
            </div>
          </van-col>
        </van-row>
        <van-row v-if="basicMessage.merchantType === 4" gutter="2">
          <van-col span="18" class="head_addres introductionIn">
            <div class="van-ellipsis">
              <img src="@/assets/images/snowflake.png" alt />
              {{ basicMessage.introductionInMall }}
            </div>
          </van-col>
          <van-col class="head_title">
            <div class="head_phone">
              <!-- <span v-if="inApp" @click="navigationClick">导航到店&ensp;></span> -->
              <img
                @click="showPopup"
                src="@/assets/images/yellowphone.png"
                alt
              />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-tabs v-model="active" sticky @click="tabClick">
      <van-tab title="最新"></van-tab>
      <van-tab title="销量"></van-tab>
      <van-tab title="价格"></van-tab>
      <van-tab title="折扣"></van-tab>
    </van-tabs>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <ul class="goods_list">
        <li class="goods_list_li" v-for="(item, i) in recordsList" :key="i">
          <div class="goods_content">
            <van-row gutter="10">
              <van-col span="10">
                <div class="goods_img" @click="productReturn(item)">
                  <img :src="item.mainPictureUrl" alt />
                </div>
              </van-col>
              <van-col span="14">
                <div class="goods_recommend">
                  <p
                    class="van-multi-ellipsis--l2"
                    @click="productReturn(item)"
                  >
                    {{ item.title }}
                  </p>

                  <div class="price_area">
                    <div class="price_current">
                      <span class="discounted">折后价</span>
                      <span class="original">￥{{ item.minPrice }}</span>
                    </div>
                    <span class="price_discount">
                      原价
                      <span class="price">￥{{ item.price }}</span>
                    </span>
                    <span v-if="item.discount !== 10" class="price_discount"
                      >{{ item.discount }}折</span
                    >
                  </div>
                  <div class="price_cart">
                    <img
                      @click="onClickButton(item)"
                      src="@/assets/images/redcart.png"
                      alt
                    />
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
          <!-- 到店自提弹窗 -->
          <div class="self_proposal">
            <van-popup
              v-model="showPicker"
              @click-overlay="overlay"
              position="bottom"
            >
              <van-picker
                title="选择到店自提"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showCancel"
              />
            </van-popup>
          </div>
          <!-- 加入购物车弹窗 -->
          <div class="cart-popup">
            <van-popup
              @click-overlay="closePopup"
              round
              v-model="cartShow"
              position="bottom"
            >
              <div class="cart-head">
                <van-row type="flex">
                  <van-col>
                    <img :src="productDetails.mainPictureUrl" />
                  </van-col>
                  <van-col>
                    <div class="cart-current">
                      <span class="cart-discounted">折后价</span>
                      <span class="cart-original">￥{{ minPriceNum }}</span>
                    </div>
                    <div class="cart_price">
                      <span>原价</span>
                      <span>￥{{ marketPrice }}</span>
                      <span>{{ skuDiscount }}折</span>
                    </div>
                    <div class="cart_price" v-if="stockShow">
                      <span>库存:{{ stockNum }}</span>
                    </div>
                  </van-col>
                </van-row>
                <!-- 购买数量 -->
                <div class="pay_num">
                  <van-cell class="pay_title" title="购买数量">
                    <span v-if="showStocks">
                      库存不足
                      <!-- <span v-if="showStocksNum">仅剩一件</span> -->
                    </span>
                    <van-stepper
                      v-model="payNum"
                      :max="stockNum"
                      @minus="minus"
                      @overlimit="overlimit"
                      @plus="plus"
                      disable-input
                    />
                  </van-cell>
                </div>
                <!-- 选择sku规格 -->
                <div
                  class="radios-sku"
                  v-for="(ProductItem, n) in simulatedDATA.specifications"
                  :key="n"
                >
                  <p class="radio-title">{{ ProductItem.name }}</p>
                  <van-radio-group
                    v-for="(items, i) in ProductItem.item"
                    :key="i"
                    v-model="getRadios[n]"
                    @change="radioChange"
                  >
                    <van-radio
                      checked-color="#ff3300"
                      class="radio-name"
                      :name="items.name"
                      shape="square"
                      >{{ items.name }}</van-radio
                    >
                  </van-radio-group>
                </div>
                <!-- 服务方式 -->
                <div class="pay_service">
                  服务方式
                  <span class="pay_explain"
                    >（选择您需要的服务方式，只可单选1种）</span
                  >
                  <div class="pay_radio">
                    <van-radio-group v-model="radios" direction="horizontal">
                      <van-radio
                        v-if="selfStores"
                        checked-color="#ff3300"
                        shape="square"
                        name="1"
                        @click="picker"
                        >到店自提</van-radio
                      >
                      <van-radio
                        v-if="notSelfStores"
                        shape="square"
                        name="2"
                        checked-color="#ff3300"
                        @click="storeExpress"
                        >快递</van-radio
                      >
                      <van-radio
                        v-if="cityDistribution"
                        shape="square"
                        checked-color="#ff3300"
                        name="3"
                        @click="cityDistributionClick"
                        >同城配送</van-radio
                      >
                    </van-radio-group>
                  </div>
                </div>
                <div>
                  <div class="btn">
                    <div class="btn_again" @click="cartBtn">确定</div>
                  </div>
                </div>
              </div>
            </van-popup>
          </div>
        </li>
      </ul>
    </van-list>
    <div class="phone_popup">
      <van-popup v-model="showPopu">
        <van-divider class="phone_title" :style="{ borderColor: '#C9CACA' }"
          >电话</van-divider
        >
        <div
          class="phone_mes"
          v-for="(item, index) in basicTelephone"
          :key="index"
        >
          <van-cell-group>
            <van-cell @click="callPhone(item)" title="服务热线" :value="item" />
          </van-cell-group>
        </div>
      </van-popup>
    </div>
    <hang-up-view ref="addCount" />
    <toast-show :showMessage="showMessage" :showToast="showToast" />
  </div>
</template>

<script>
import hangUpView from '@/components/content/hangUpView'
import shopNavBar from '@/components/content/shopNavBar'
import toastShow from '@/components/content/toastShow'
import { PLATFORM_TYPE, PRODUCT_ENQUIRY } from '@/config/platformtype'
import { FRONTEND_HOST } from '@/config/domainnameconstant'
import {
  productSku,
  shopBasicMessage,
  summaryInformation,
  addCarts,
  dataCollection,
} from '@/api/productsDetaile'
import { getDefaultAddress } from '@/api/shippingAddress'
import follow from '@/api/follow.js'

export default {
  name: 'Moreshpes',
  data() {
    return {
      skuDiscount: 0,
      marketPrice: 0,
      active: 0,
      showPopu: false,
      inApp: false,
      skuIdTrue: false,
      showBusinessTime: false,
      productDetails: {},
      radioStatus: false,
      mainImg: false,
      productsId: '',
      dataStatus: true,
      showStocks: false,
      shopingAddId: 0,
      isStoredId: '',
      isProductId: '',
      selfObject: {},

      getMethods: '',
      payNum: 1,
      getstoreId: '',
      selfStoreId: [],
      stockShow: false,
      minPriceNum: '',
      stockNum: 100,
      storeNamesList: [],
      selfStores: false,
      notSelfStores: false,
      cityDistribution: false,
      goodsSkuId: '',
      getRadios: [],
      showPicker: false,
      columns: ['', '', '', ''],
      storeBasicList: {},
      basicTelephone: [],
      simulatedDATA: {
        // 模拟后台返回的数据 多规格
        difference: [
          // 所有的规格可能情况都在这个数组里
          {
            id: '',
            price: '',
            stock: '', // 库存
            difference: '', // 此规格的属性键值
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
          {
            id: '',
            price: '',
            stock: '',
            difference: '',
          },
        ],
        // 展示给用户看的规格
        specifications: [
          {
            // 这里是要被渲染字段
            name: '',
            item: [
              {
                name: '',
              },
              {
                name: '',
              },
            ],
          },
          {
            name: '',
            item: [
              {
                name: '',
              },
              {
                name: '',
              },
              {
                name: '',
              },
            ],
          },
        ],
      },
      totalCount: 0,
      storeId: 0,
      listQuery: {
        size: 10,
        current: 1,
        platform: PRODUCT_ENQUIRY,
        storeId: 0,
        isNew: true,
      },
      recordsList: [],
      currentPage: 1,
      basicMessage: {},
      radios: '',
      cartShow: false,
      showMessage: '',
      showToast: false,
      watchIco: false,
      list: [],
      loading: false,
      finished: false,
      stars: 3,
      activeClik: 0,
      current: 0,
      isShow: true,
      imgSrc: require('@/assets/images/u2942.jpg'),
    }
  },
  components: {
    hangUpView,
    shopNavBar,
    toastShow,
  },
  filters: {
    // 营业时间
    showBuinessTime(timestr) {
      // "周六,周日#24小时营业;周四,周五#00:01,00:28;周六#24小时营业" 这是时间的demo
      // timestr = '周六,周日#24小时营业;周四,周五#00:01,00:28;周六#24小时营业'
      let txt = ''
      timestr.split(';').forEach((value) => {
        value.split('#').forEach((ele) => {
          if (ele.includes(':')) {
            txt += ele.replace(',', '-') // 如果是逗号,那就是时间段,替换成-号
          } else {
            txt += ele
          }
          txt += ' '
        })
        // txt += '<br>'
      })
      return txt
    },
  },
  created() {
    this.storeId = this.$route.query.id
    this.storeInformation()
    this.toCollection()
    this.judgementApp()
  },

  methods: {
    // 判断是否app环境
    judgementApp() {
      this.inApp = this.$getIsApp()
    },
    // 采集访客数据
    toCollection() {
      const storeId = this.storeId
      dataCollection(storeId).then((res) => {
        if (res.data.code == 200) {
        }
      })
    },
    // 判断提货方式
    getdeliveryMethod(index) {
      const arr = index.split(',')
      arr.forEach((val) => {
        if (val === '0') {
          this.selfStores = true
        }
        if (val === '1') {
          this.notSelfStores = true
        }
        if (val === '2') {
          this.cityDistribution = true
        }
      })
    },
    showPopup() {
      this.showPopu = true
    },
    closePopup() {
      this.radioNull()
      this.getMethods = ''
    },
    // 购物车弹窗确定
    cartBtn() {
      if (this.getMethods == 2) {
        const cityMoney = this.payNum * this.minPriceNum
        if (cityMoney < this.productDetails.cityDistributionAmountLimit) {
          this.showMessage =
            '金额不足' +
            this.productDetails.cityDistributionAmountLimit +
            '元,请重新选择产品数量、规格'
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 2000)
          return
        }
      }
      // 添加购物车接口
      if (!this.token) {
        this.showMessage = '您还未登录,即将跳转到登录界面'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
          if (this.$getIsApp()) {
            this.$callApp('Android', 'AppLogin', '')
            this.$callApp('iOS', 'AppLoginMethod', '')
          }
        }, 2000)
      } else if (this.payNum == '' || this.stockNum == 0) {
        this.showMessage = '商品库存不足'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 3000)
      } else {
        const loading = this.$toast.loading({
          overlay: true,
          forbidClick: true,
          duration: 0,
          message: '请稍等...',
        })
        addCarts({
          storeSelfMentionId: this.getstoreId,
          storeId: this.storeId,
          quantity: this.payNum,
          productSkuId: this.goodsSkuId,
          deliveryMethod: this.getMethods,
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.cartShow = false
              this.$refs.addCount.getCount()
            }
          })
          .catch((err) => {
            this.showMessage = err.msg
            this.showToast = true
            setTimeout(() => {
              this.showToast = false
            }, 3000)
          })
          .finally(() => loading.clear())
      }
    },
    // 点击增加按钮触发去掉库存不足
    plus() {
      this.showStocks = false
    },
    // 点击减少按钮触发去掉库存不足
    minus() {
      this.showStocks = false
    },
    // 库存不足显示
    overlimit() {},
    // 到店自提radio按钮
    radioNull() {
      this.radios = ''
    },
    onConfirm(value) {
      this.value = value
      const valueId = this.columns.indexOf(value)
      this.getstoreId = this.selfStoreId[valueId]
      this.showPicker = false
    },
    showCancel() {
      this.showPicker = false
      this.radioNull()
    },
    overlay() {
      this.radioNull()
    },
    // 到店自提radio
    picker() {
      this.radios = '1'
      this.getMethods = 0
      if (this.storeNamesList.length > 0 && this.storeNamesList[0] !== '') {
        this.columns = this.storeNamesList
        // this.showPicker = true
        if (this.columns.length == 1) {
          this.getstoreId = this.selfStoreId[0]
        } else if (this.columns.length > 1) {
          this.showPicker = true
        }
      }
    },
    // 快递radio
    storeExpress() {
      this.radios = '2'
      this.getMethods = 1
    },
    // 同城按钮
    cityDistributionClick() {
      this.radios = '3'
      this.getMethods = 2
    },
    radioChange() {
      this.simulatedDATA.difference.forEach((val, index) => {
        const valArr = val.difference.split(',')
        if (this.simulatedDATA.specifications.length == 1) {
          const retun = valArr.indexOf(this.getRadios[0]) !== -1
          this.radioStatus = retun
        } else if (this.simulatedDATA.specifications.length == 2) {
          const retun =
            valArr.indexOf(this.getRadios[0]) !== -1 &&
            valArr.indexOf(this.getRadios[1]) !== -1
          this.radioStatus = retun
        }
        if (this.radioStatus) {
          this.skuIdTrue = true
          this.goodsSkuId = val.id
          this.minPriceNum = val.price
          this.skuDiscount = (this.minPriceNum / this.marketPrice).toFixed(2)
          this.stockShow = true
          this.stockNum = val.stock
        }
      })
    },
    // 获取产品sku信息
    getproductSku(ids) {
      productSku({
        productId: ids,
        platformType: PLATFORM_TYPE,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.skusList = res.data.data

            // 规格去重分组
            var mapper = {}
            var group = {}
            this.skusList.forEach((r, i) => {
              r.specifications.forEach((rr, ii) => {
                if (!group.hasOwnProperty(rr.productAttributeId)) {
                  group[rr.productAttributeId] = []
                  mapper[rr.productAttributeId] =
                    's' + Object.keys(group).length
                }
                try {
                  group[rr.productAttributeId].forEach((rrr, iii) => {
                    if (rrr.val === rr.val) throw new Error()
                  })
                  group[rr.productAttributeId].push(rr)
                } catch (e) {}
              })
            })
            // tree
            var tree = []
            Object.keys(group).forEach((r, i) => {
              const item = group[r]
              var treeItem = {
                name: item[0].productAttributeName,
                item: [],
              }
              item.forEach((rr, ii) => {
                treeItem['item'].push({
                  name: rr.val,
                })
              })
              tree.push(treeItem)
            })
            // list
            var list = []
            this.skusList.forEach((r, i) => {
              const listItem = {}
              listItem.id = r.id
              listItem.price = r.platformPrice
              listItem.stock = r.stock
              listItem.marketPrice = r.marketPrice
              listItem.difference = ''
              r.specifications.forEach((rr, ii) => {
                listItem.difference = listItem.difference + rr.val + ','
              })

              listItem.difference = listItem.difference.substring(
                0,
                listItem.difference.length - 1
              )

              list.push(listItem)
            })
            this.simulatedDATA.specifications = tree
            this.simulatedDATA.difference = list
            // 默认选择规格
            if (this.simulatedDATA.difference[0].difference) {
              this.getRadios[0] = this.simulatedDATA.difference[0].difference
              this.goodsSkuId = this.simulatedDATA.difference[0].id
              this.stockNum = this.simulatedDATA.difference[0].stock
              this.minPriceNum = this.simulatedDATA.difference[0].price
              this.marketPrice = this.simulatedDATA.difference[0].marketPrice
              this.skuDiscount = (this.minPriceNum / this.marketPrice).toFixed(
                2
              )
              this.stockShow = true

              const differenceList = this.simulatedDATA.difference[0].difference.split(
                ','
              )
              if (differenceList.length > 1) {
                this.getRadios[0] = differenceList[0]
                this.getRadios[1] = differenceList[1]
                this.stockNum = this.simulatedDATA.difference[0].stock
                this.marketPrice = this.simulatedDATA.difference[0].marketPrice
                this.skuDiscount = (
                  this.minPriceNum / this.marketPrice
                ).toFixed(2)
                this.stockShow = true
              }
            }
            // 当没有规格选择时，默认直接拿id
            if (this.skusList[0].specifications.length === 0) {
              this.goodsSkuId = this.skusList[0].id
              this.stockNum = this.skusList[0].stock
              this.minPriceNum = this.skusList[0].platformPrice
              this.marketPrice = this.skusList[0].marketPrice
              this.skuDiscount = (
                this.skusList[0].platformPrice / this.marketPrice
              ).toFixed(2)
              this.skuIdTrue = true
            }
          }
        })
        .catch((result) => {})
    },
    // 取消关注店铺接口
    notFollow() {
      const removeFollow = []
      removeFollow.push(this.storeId)
      follow.cancellationShops(removeFollow).then((res) => {
        if (res.data.code == 200) {
          if (this.watchIco) {
            this.showMessage = '取消关注'
            this.showToast = true
            if (this.basicMessage.follows !== 0) {
              this.basicMessage.follows = this.basicMessage.follows - 1
            }
            setTimeout(() => {
              this.showToast = false
            }, 1000)
          } else {
            this.showMessage = '成功关注'
            this.showToast = true
            this.basicMessage.follows = this.basicMessage.follows + 1
            setTimeout(() => {
              this.showToast = false
            }, 1000)
          }
        }
      })
    },
    // 关注店铺接口
    toFollow() {
      follow.focusShops(this.storeId).then((res) => {
        if (res.data.code == 200) {
          if (this.watchIco) {
            this.showMessage = '取消关注'
            this.showToast = true
            if (this.basicMessage.follows !== 0) {
              this.basicMessage.follows = this.basicMessage.follows - 1
            }
            setTimeout(() => {
              this.showToast = false
            }, 1000)
          } else {
            this.showMessage = '成功关注'
            this.showToast = true
            this.basicMessage.follows = this.basicMessage.follows + 1
            setTimeout(() => {
              this.showToast = false
            }, 1000)
          }
        }
      })
    },
    // 头部tabclick点击
    tabClick(index) {
      if (index == 0) {
        this.listQuery = {
          size: 10,
          current: 1,
          platform: PRODUCT_ENQUIRY,
          storeId: this.storeId,
          isNew: true,
        }
        this.loading = true
        this.recordsList = []
      } else if (index == 1) {
        this.recordsList = []
        this.loading = true
        this.listQuery = {
          size: 10,
          current: 1,
          platform: PRODUCT_ENQUIRY,
          storeId: this.storeId,
          isHotSale: true,
        }
      } else if (index == 2) {
        this.recordsList = []
        this.loading = true

        this.listQuery = {
          size: 10,
          current: 1,
          platform: PRODUCT_ENQUIRY,
          storeId: this.storeId,
          isPriceAsc: true,
        }
      } else if (index == 3) {
        this.loading = true
        this.recordsList = []
        this.listQuery = {
          size: 10,
          current: 1,
          platform: PRODUCT_ENQUIRY,
          storeId: this.storeId,
          isDiscountAsc: true,
        }
      }
      this.finished = false
      this.onLoad()
    },
    // 店铺基本头部信息接口
    storeInformation() {
      shopBasicMessage({
        id: this.$route.query.id,
        platformType: PRODUCT_ENQUIRY,
      }).then((res) => {
        if (res.data.code == 200) {
          this.basicMessage = res.data.data
          if (this.basicMessage.name) {
            window.document.title = this.basicMessage.name
          }

          this.basicTelephone = this.basicMessage.telephone.split(',')
          if (this.basicMessage.businessTime) {
            this.showBusinessTime = true
          }
          if (this.basicMessage.followed) {
            this.watchIco = false
          } else {
            this.watchIco = true
          }
        }
      })
    },
    isDefaulAddress() {
      // 查询默认收货地址
      getDefaultAddress().then((res) => {
        if (res.data.code === 200) {
          if (res.data.data === null || !res.data.data) {
            this.$store.commit('orderdata/setIdNum', {
              isStoredId: this.storeId,
              isProductId: this.$route.query.id,
            })
            // const that = this
            if (this.shopingAddId === '' || this.shopingAddId === undefined) {
              this.$router.push({
                path: '/mall/add-address',
                query: {
                  productListStatus: 6,
                  identity: this.identity,
                },
              })
            }
          }
        }
      })
    },
    onClickButton(item) {
      // 调用查询默认地址
      if (this.token) {
        this.isDefaulAddress()
      }
      this.getproductSku(item.id)
      this.selfStores = false
      this.notSelfStores = false
      this.cityDistribution = false
      this.productDetails = item
      // 服务方式调取
      this.getdeliveryMethod(this.productDetails.deliveryMethod)
      if (this.productDetails.storeNames) {
        this.storeNamesList = this.productDetails.storeNames.split(',')
      }
      // 只提门店id
      if (this.productDetails.storeIds) {
        this.selfStoreId = this.productDetails.storeIds.split(',')
      }
      // 默认服务方式选择
      if (this.selfStores && this.notSelfStores && this.cityDistribution) {
        this.storeExpress()
      } else if (this.notSelfStores) {
        this.storeExpress()
      } else if (this.cityDistribution) {
        this.cityDistributionClick()
      } else if (this.selfStores) {
        if (this.storeNamesList.length === 1) {
          this.picker()
        }
      }
      this.cartShow = !this.cartShow
    },
    onLoad() {
      this.listQuery.storeId = this.$route.query.id
      summaryInformation(this.listQuery).then((res) => {
        if (res.data.code === 200) {
          // 加载状态结束
          this.loading = false
          this.recordsList = this.recordsList.concat(res.data.data.records)
          // 购物车弹窗规格原价钱
          // 数据全部加载完成
          this.listQuery.current++
          this.totalCount = res.data.data.total
          if (this.recordsList.length >= this.totalCount) {
            this.finished = true
          }
          // 处理数组
          this.recordsList.forEach((el, index) => {
            this.minPriceNum = el.minPrice
            el.minPriceNum = this.minPriceNum
          })
        }
      })
    },
    productReturn(item) {
      const salesStoreIdArr = item.salesStoreIds.split(',')
      if (salesStoreIdArr.length != 0) {
        this.$router.push({
          path: '/mall/detail',
          query: {
            id: item.id,
            storeId: salesStoreIdArr[0],
            identity: this.identity,
          },
        })
      }
    },
    callPhone(phoneNumber) {
      window.location.href = 'tel:' + phoneNumber
    },
    // 导航
    navigationClick() {
      const navigation = {
        latitude: this.basicMessage.latitude,
        longitude: this.basicMessage.longitude,
        shopName: this.basicMessage.name,
      }
      this.$callApp('Android', 'AppNavigateMethod', JSON.stringify(navigation))
      this.$callApp('iOS', 'AppNavigateMethod', navigation)
    },
    // 未关注灰色
    notWatchClick() {
      this.watchIco = false
      this.toFollow()
    },
    // 已关注
    watchClick() {
      this.watchIco = true
      this.notFollow()
    },
  },
}
</script>

<style lang="less" scoped>
//电话弹出框
.phone_popup {
  .phone_title {
    color: #595757;
    padding: 0 8px;
    font-size: 15px;
    text-align: center;
    margin: 15px 0 15px 0;
  }
  .van-popup--center {
    width: 275px;
    height: 241.5px;
  }
  .van-cell {
    color: #3e3a39;
    line-height: 16.5px;
    font-size: 15px;
    padding: 7.5px 12.5px;
  }
}
#shops {
  background: #efefef;
  min-height: 100vh;
}

* {
  padding: 0px;
  margin: 0px;
}

.boder_top {
  border-top: 5px #efefef solid;
}

//店铺头像css
.head_content {
  margin-top: 44.5px;
  position: relative;

  .store_navigation {
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    margin-top: 15px;
    //店铺名字
    .store-name {
      display: inline-block;
      font-size: 15px;
      color: white;
      padding-top: 10px;
    }
    //左边
    .head_img {
      margin: 0px 15px 16px;

      img {
        border: 1px solid #eee;
        border-radius: 7.5px;
        width: 87px;
        height: 87px;
      }
    }

    //右边
    .head_store {
      font-size: 15px;
      color: #fff;

      .head_title {
        margin-bottom: 15px;
      }

      .head_desc {
        margin-bottom: 6px;
      }
    }

    .head_watch {
      padding-top: 8px;
      font-size: 15px;
      .follow-num {
        color: #fff;
      }
      margin-bottom: 7.5px;
      /deep/.van-tag--default.van-tag--plain {
        overflow: hidden;
        margin: 0px 0px 0px 7.5px;
        padding: 2px 10px;
        font-size: 15px;
        background: -webkit-gradient(
          linear,
          left 0,
          right 100%,
          from(#ddb8c8),
          to(#ff0600)
        );
      }
    }
    .introductionIn {
      color: #fff;
      font-size: 15px;
    }
    .head_addres {
      margin: 0px 0px 0px 15px;

      img {
        width: 13.5px;
        height: 16px;
      }

      span {
        font-size: 15px;
        color: #fff;
      }
    }

    .head_phone {
      span {
        font-size: 12px;
        color: #fff;
      }

      img {
        padding-left: 7.5px;
        width: 15px;
        height: 15px;
      }
    }

    .head_phone span::after {
      content: '|';
      color: #fff;
      margin: 0px 2.5px 0px 5px;
      font-size: 15px;
    }
    .van-row {
      margin: 0 !important;
    }
  }

  .bgImg {
    background: #a5a3a4;

    img {
      opacity: 0.4;
      width: 375px;
      height: 180px;
      // height: 204px;
    }
  }
}

//tab 导航栏
.tab_control {
  position: sticky;
  z-index: 3;
  top: 44px;
}

//商品列表
.goods_list {
  .goods_list_li {
    border-radius: 7.5px;
    background: #fff;
    margin: 7px 0;
  }
  .goods_content {
    height: 134px;
    padding: 15px 15px;

    .goods_img img {
      height: 134px;
      width: 134px;
      border-radius: 7.5px;
    }

    .goods_recommend {
      position: relative;

      .goods_make_money {
        margin-top: 7.5px;

        .goods_return {
          border-radius: 2.5px;
          color: #fff;
          margin-right: 5px;
          font-size: 12px;
          background: #c31c1f;
          border: 1px solid #c31c1f;

          span {
            color: #c31c1f;
            background: white;
          }
        }

        .goods_works {
          border-radius: 2.5px;
          color: #fff;
          margin-right: 5px;
          font-size: 12px;
          background: #2ea7e0;
          border: 1px solid #2ea7e0ed;

          span {
            color: #2ea7e0;
            background: white;
          }
        }
      }

      p {
        vertical-align: middle;
        font-size: 14px;
      }

      .price_cart {
        position: absolute;
        bottom: -10px;
        right: 0;

        img {
          width: 40px;
          height: 40.5px;
        }
      }
    }

    //折后价
    .price_area {
      margin: 17.5px 0px;
      span {
        margin: 0px 4px;
      }

      .price_current {
        margin-bottom: 10px;
      }

      .discounted {
        vertical-align: bottom;
        width: 56px;
        height: 23px;
        line-height: 23px;
        display: inline-block;
        padding: 2.5px;
        color: white;
        font-size: 15px;
        text-align: center;
        background: @discount-price;
        opacity: 0.6;
        border-radius: 7.5px;
      }

      .price {
        text-decoration: line-through;
        font-size: 12px;
        color: #9fa0a0;
      }

      .original {
        font-size: 22px;
        color: #595757;
      }

      .price_discount {
        line-height: 13px;
        // margin-left: 14px;
        font-size: 12px;
        color: #9fa0a0;
      }
    }
  }
}

//推荐
.store_recommend {
  border-radius: 7.5px;
  padding-top: 15px;
  background: #fff;

  h3 {
    font-size: 15px;
    margin: 0px 0 12.5px 132.5px;
  }
}

.recommend_flow {
  //轮播图我要播边框
  /deep/ .van-grid-item__content {
    border-radius: 2px;
    margin: 0px;
    padding: 0px;

    span {
      padding: 3.5px 0;
      font-size: 10px;
    }

    img {
      width: 100%;
      height: 77px;
    }

    div {
      width: 100%;
      line-height: 25px;
      font-size: 15px;
      text-align: center;
    }
  }

  .van-swipe {
    border-radius: 7.5px;
  }

  /deep/ .van-grid-item__content {
    border: none;

    div {
      width: 77px;
      line-height: 17px;
      font-size: 12px;
      color: black;
      background: white;
    }

    span {
      width: 77px;
      color: #c30d23;
      font-size: 12px;
      text-align: center;
    }

    img {
      border-radius: 7.5px;
      width: 77px;
      height: 77px;
    }
  }
}
//加入购物车弹窗
/deep/ .cart-popup {
  .cart-head {
    padding: 15px 0px 0px 12px;
    img {
      padding-right: 10px;
      width: 100px;
      height: 100px;
    }
    //折后价
    .cart-current {
      padding-top: 12.5px;
      .cart-discounted {
        width: 56px;
        height: 21px;
        line-height: 21px;
        display: inline-block;
        padding: 2.5px;
        color: white;
        font-size: 15px;
        text-align: center;
        background: @discount-price;
        border-radius: 10.5px;
      }
      .cart-original {
        padding-left: 7.5px;
        vertical-align: middle;
        font-size: 25px;
      }
    }
    //原价
    .cart_price {
      color: #969799;
      padding-top: 9px;
      span {
        font-size: 14px;
        padding: 0 3.5px 0 3.5px;
      }
      span:nth-of-type(2) {
        text-decoration: line-through;
      }
    }
    //返现
    .goods_make_money {
      margin: 12px 4px 0px;
      padding: 2.5px 0px;
      width: 42%;
      border: 1px solid #fd130e;
      border-radius: 2.5px;
      font-size: 12px;
      .goods-return {
        background: #fd130e;
        padding: 2.5px;
        color: #fff;
      }
      .goods-return-money {
        padding: 2.5px;
        color: #c31c1f;
      }
    }
  }
  //购买数量
  .pay_num {
    margin-right: 7.5px;
    padding: 15px 0px;
    .pay_title {
      font-size: 15px;
      line-height: 35px;
    }
    //input输入
    .van-stepper__minus {
      height: 28px;
      width: 28px;
    }
    .van-stepper__input {
      height: 28px;
      margin: 0;
      width: 28px;
      font-size: 12px;
    }
    .van-stepper__plus {
      height: 28px;
      width: 28px;
    }
  }
  // 商品radio的sku
  .radios-sku {
    .radio-title {
      padding: 5px 0;
      font-size: 15px;
    }
    .radio-name {
      padding: 4px 0;
      font-size: 14px;
    }
    .van-radio__icon {
      font-size: 15px;
    }
  }
  //服务方式
  .pay_service {
    font-size: 15px;
    .pay_explain {
      font-size: 12px;
      color: #969799;
    }
    .pay_radio {
      padding-top: 7px;
      padding-bottom: 7px;
      .van-radio-group--horizontal {
        height: 20px;
      }
      .van-radio__icon {
        font-size: 12px;
      }
    }
    .van-radio__label {
      margin-right: 30px;
    }
  }
  //遮罩层
  .van-overlay {
    background-color: rgba(0, 0, 0, 0.1);
  }
  //确认按钮
  .btn {
    .btn_again {
      background-color: @buy-now-background;
      color: #fff;
      width: 345px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      border-radius: 25px;
      margin: 10px 0px;
    }
  }
}
//自提弹窗
/deep/ .self_proposal {
  .van-picker__toolbar {
    height: 40px;
    line-height: 40px;
  }
  .van-picker__title {
    font-size: 15px;
    color: black;
  }
  .van-picker-column__item {
    font-size: 15px;
  }
  .van-picker__cancel,
  .van-picker__confirm {
    font-size: 13px;
  }
  .van-overlay {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>
